<div *ngIf="sentenceData">
    <div [ngClass]="embedded ? 'embedded-ai-analysis' : 'container'">

    <div class="content">
        <div *ngIf="!embedded" class="sentence-information-section">
            <div class="sentence-info-header">
                <h3 tabindex="-1" #analysisTitle>{{ (isWindowData() ? 'ai_sentence_analysis.segment_information' : 'report.sentence_information') | translate }}</h3>
                <button class="close-button sentence-info-close" (click)="close()" [attr.aria-label]="'ai_sentence_analysis.close_analysis' | translate">
                    <img src="../../../../../assets/report_v2/close_big.svg" alt="Close">
                </button>
            </div>
        </div>

        <div *ngIf="isWindowData()">
            <div class="ai-predicted-box">
                <div class="ai-predicted-header">
                    <div class="ai-badge-circle">!</div>
                    <h3>{{ 'ai_sentence_analysis.ai_predicted' | translate }}</h3>
                </div>

                <div class="confidence-message" [innerHTML]="'ai_sentence_analysis.confident_message' | translate">
                </div>

                <div class="segment-stats">
                    <span class="stat-item">{{ 'ai_sentence_analysis.ai_confidence' | translate }}: <strong>{{ getAIConfidenceFromWindow() }}%</strong></span>
                    <span class="stat-divider">|</span>
                    <span class="stat-item">{{ 'ai_sentence_analysis.word_count_label' | translate }}: <strong>{{ getWordCountFromWindow() }}</strong></span>
                </div>
            </div>

            <div class="flagged-segment-section">
                <h4>{{ 'ai_sentence_analysis.flagged_ai_segment' | translate }}</h4>
                <div class="segment-text" [innerHTML]="getHighlightedWindowText()"></div>
            </div>

        </div>

        <!-- Legacy sentence view - fallback for non-window data -->
        <div class="ai-detected-section" *ngIf="!isWindowData()">
            <h3>{{ 'ai_sentence_analysis.detected_ai_sentence' | translate }}</h3>
            <div class="sentence-text"
                [innerHTML]="getHighlightedText(getSentenceText(), sentenceData.pangramResults?.aiSentenceKeywords)">
            </div>

            <div class="ai-likelihood-section" *ngIf="sentenceData.pangramResults?.aiSentenceFrequency">
                <div class="likelihood-indicator">
                    <span class="likelihood-number"><img src="../../../../../assets/report_v2/info-empty-filled.png"
                            alt="AI Likelihood" /></span>
                    <div class="likelihood-content">
                        <h4>{{ 'ai_sentence_analysis.ai_likelihood_frequency' | translate }}</h4>
                        <p class="likelihood-text" [innerHTML]="'ai_sentence_analysis.ai_likelihood_text' | translate: { frequency: (sentenceData.pangramResults.aiSentenceFrequency | number:'1.0-1') }">
                        </p>
                    </div>
                </div>
            </div>

            <div class="detected-keywords-section"
                *ngIf="sentenceData.pangramResults?.aiSentenceKeywords && sentenceData.pangramResults.aiSentenceKeywords.length > 0">

                <div class="keywords-table">
                    <div class="keywords-header-row">
                        <div class="keywords-header-cell">
                            <span>{{ 'ai_sentence_analysis.detected_keyword' | translate }}</span>
                            <button matTooltipClass="new_report_tooltip persistent-tooltip"
                                [matTooltip]="'ai_sentence_analysis.detected_keyword_tooltip' | translate"
                                matTooltipPosition="above" [attr.aria-label]="'ai_sentence_analysis.detected_keyword_tooltip' | translate">
                                <img src="../../../../../assets/report_v2/info-empty.svg" alt="Info" />
                            </button>
                        </div>
                        <div class="keywords-header-cell align-right">
                            <span>{{ 'ai_sentence_analysis.keyword_frequency' | translate }}</span>
                            <button matTooltipClass="new_report_tooltip persistent-tooltip"
                                [matTooltip]="'ai_sentence_analysis.keyword_frequency_tooltip' | translate"
                                matTooltipPosition="above" [attr.aria-label]="'ai_sentence_analysis.keyword_frequency_tooltip' | translate">
                                <img src="../../../../../assets/report_v2/info-empty.svg" alt="Info" />
                            </button>
                        </div>
                    </div>

                    <div class="keyword-row" *ngFor="let keyword of sentenceData.pangramResults.aiSentenceKeywords">
                        <div class="keyword-name">{{ keyword.keyword }}</div>
                        <div class="keyword-frequency">
                            <span class="frequency-chip">{{ keyword.frequency | number:'1.0-0' }}x</span>
                            <span class="stat-label">{{ 'ai_sentence_analysis.more_frequent_in_ai' | translate }}</span>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <div class="footer" *ngIf="!embedded">
            <button class="secondary-button" (click)="close()">{{ 'general.close' | translate }}</button>
        </div>
    </div>

    <div class="panel-footer" *ngIf="!embedded && isWindowData() && totalSegments > 0">
        <div class="finding-navigation">
            <div class="nav-row">
                <span class="finding-counter">
                    {{ 'ai_sentence_analysis.segment_counter' | translate: { current: currentSegmentIndex + 1, total: totalSegments } }}
                </span>
                <div class="nav-buttons">
                    <button class="nav-btn" [disabled]="!hasPreviousSegment"
                        [ngClass]="{'disabled': !hasPreviousSegment}"
                        (click)="navigateSegment('previous')"
                        [attr.aria-label]="'ai_sentence_analysis.previous_segment' | translate">
                        <img src="../../../../../assets/images/arrow_previous.png" alt="" aria-hidden="true" class="nav-btn-icon" />
                        {{ 'ai_sentence_analysis.previous' | translate }}
                    </button>
                    <button class="nav-btn" [disabled]="!hasNextSegment"
                        [ngClass]="{'disabled': !hasNextSegment}"
                        (click)="navigateSegment('next')"
                        [attr.aria-label]="'ai_sentence_analysis.next_segment' | translate">
                        {{ 'ai_sentence_analysis.next' | translate }}
                        <img src="../../../../../assets/images/arrow_next.png" alt="" aria-hidden="true" class="nav-btn-icon" />
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>

    <div class="powered-by-pangram" *ngIf="!embedded">
        <span>{{ 'authorship_in_depth.powered_by_pangram' | translate }}</span>
        <img src="../../../../../assets/images/pangram.png" alt="Pangram logo" class="pangram-logo">
    </div>
</div>